"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[643],{

/***/ 20667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  word-wrap: break-word;\n  word-break: break-all;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const BreakWordTypography = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (BreakWordTypography);


/***/ }),

/***/ 47216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    margin: 0;\n  }\n\n  .ql-align-center {\n    text-align: center;\n  }\n  .ql-align-right {\n    text-align: right;\n  }\n  .ql-align-justify {\n    text-align: justify;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    font-size: 18px;\n    letter-spacing: 0.02rem;\n    line-height: 2rem;\n  }\n\n  img {\n    margin: 18px 0;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject());
const ArticleContent = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Content)(_templateObject1());
const HTMLContent = (param)=>{
    let { content , type  } = param;
    if (!content) {
        return null;
    }
    return type === "article" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArticleContent, {
        dangerouslySetInnerHTML: {
            __html: content
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, {
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HTMLContent);


/***/ }),

/***/ 20643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ModuleContentWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66411);
/* harmony import */ var _ModuleTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90806);
/* harmony import */ var components_common_HTMLContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47216);




const HTMLModule = (param)=>{
    let { data , isServicePage =false  } = param;
    var _data_customHtmlModule, _data_customHtmlModule1, _data_customHtmlModule2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModuleContentWrapper__WEBPACK_IMPORTED_MODULE_1__/* .MediumContentWrapper */ .mZ, {
        $isServicePage: isServicePage,
        children: [
            (data === null || data === void 0 ? void 0 : (_data_customHtmlModule = data.customHtmlModule) === null || _data_customHtmlModule === void 0 ? void 0 : _data_customHtmlModule.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModuleTitle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: data === null || data === void 0 ? void 0 : (_data_customHtmlModule1 = data.customHtmlModule) === null || _data_customHtmlModule1 === void 0 ? void 0 : _data_customHtmlModule1.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_HTMLContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                content: data === null || data === void 0 ? void 0 : (_data_customHtmlModule2 = data.customHtmlModule) === null || _data_customHtmlModule2 === void 0 ? void 0 : _data_customHtmlModule2.content
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HTMLModule);


/***/ }),

/***/ 66411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mZ": function() { return /* binding */ MediumContentWrapper; }
/* harmony export */ });
/* unused harmony exports LargeContentWrapper, MediumContentWrapperWithoutPadding */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var config_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26059);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}





const StyledLargeContentWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $xs , $lg , $xl , $xxl , $widthLimit , $isServicePage , $isHomePage  } = param;
    return "\n    width: 100%;\n    max-width: ".concat($widthLimit ? $isHomePage ? config_theme__WEBPACK_IMPORTED_MODULE_4__/* .indexPageMaxContentWidth */ .LN : config_theme__WEBPACK_IMPORTED_MODULE_4__/* .maxContentWidth */ .xN : "none", ";\n    margin-left: auto;\n    margin-right: auto;\n\n    padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0), ";\n    padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0), ";\n\n    ").concat($isHomePage ? "\n        padding-left: ".concat(theme.spacing($xs ? 4 : 0), ";\n        padding-right: ").concat(theme.spacing($xs ? 4 : 0), ";\n\n        ").concat(theme.breakpoints.up("md"), " {\n          padding-left: ").concat(theme.spacing(8), ";\n          padding-right: ").concat(theme.spacing(8), ";\n        }\n\n        ").concat(theme.breakpoints.up("xl"), " {\n          padding-left: ").concat(theme.spacing($xl ? 12 : 0), ";\n          padding-right: ").concat(theme.spacing($xl ? 12 : 0), ";\n          border-radius: 24px;\n        }\n      ") : "\n        ".concat(theme.breakpoints.up("lg"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0), ";\n        }\n\n        ").concat(theme.breakpoints.up("xl"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0), ";\n        }\n\n        ").concat(theme.breakpoints.up("xxl"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0), ";\n        }\n      "), "\n  ");
});
const LargeContentWrapper = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const isHomePage = router.pathname === "/";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLargeContentWrapper, {
        ...props,
        $isHomePage: isHomePage
    });
};
const StyledMediumContentWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme , $xs , $lg , $xl , $xxl , $isServicePage , $isHomePage  } = param;
    return "\n    width: 100%;\n    max-width: ".concat($isHomePage ? config_theme__WEBPACK_IMPORTED_MODULE_4__/* .indexPageMaxContentWidth */ .LN : config_theme__WEBPACK_IMPORTED_MODULE_4__/* .maxContentWidth */ .xN, ";\n    margin-left: auto;\n    margin-right: auto;\n\n    padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0), ";\n    padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0), ";\n\n    ").concat($isHomePage ? "\n        ".concat(theme.breakpoints.up("md"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing(8), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing(8), ";\n        }\n\n        ").concat(theme.breakpoints.up("xl"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0), ";\n        }\n      ") : "\n        ".concat(theme.breakpoints.up("lg"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0), ";\n        }\n\n        ").concat(theme.breakpoints.up("xl"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0), ";\n        }\n\n        ").concat(theme.breakpoints.up("xxl"), " {\n          padding-left: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0), ";\n          padding-right: ").concat($isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0), ";\n        }\n      "), "\n  ");
});
const MediumContentWrapper = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const isHomePage = router.pathname === "/";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledMediumContentWrapper, {
        ...props,
        $isHomePage: isHomePage
    });
};
const StyledMediumContentWrapperWithoutPadding = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject2(), (param)=>{
    let { $isHomePage  } = param;
    return "\n    width: 100%;\n    max-width: ".concat($isHomePage ? config_theme__WEBPACK_IMPORTED_MODULE_4__/* .indexPageMaxContentWidth */ .LN : config_theme__WEBPACK_IMPORTED_MODULE_4__/* .maxContentWidth */ .xN, ";\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0;\n  ");
});
const MediumContentWrapperWithoutPadding = (props)=>{
    const router = useRouter();
    const isHomePage = router.pathname === "/";
    return /*#__PURE__*/ _jsx(StyledMediumContentWrapperWithoutPadding, {
        ...props,
        $isHomePage: isHomePage
    });
};
LargeContentWrapper.defaultProps = {
    $xs: true,
    $lg: true,
    $xl: true,
    $xxl: true,
    $widthLimit: true,
    $isServicePage: false
};
MediumContentWrapper.defaultProps = {
    $xs: true,
    $lg: true,
    $xl: true,
    $xxl: true,
    $isServicePage: false
};


/***/ }),

/***/ 90806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_common_BreakWordTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20667);


const ModuleTitle = (param)=>{
    let { title , isNarrow =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BreakWordTypography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "h4",
        fontWeight: "fontWeightBold",
        component: "h1",
        mb: {
            xs: isNarrow ? 4 : 8,
            lg: isNarrow ? 6 : 8
        },
        color: "text.primary",
        children: title
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModuleTitle);


/***/ })

}]);